import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TikTokFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.2934 3H12.5312V15.2608C12.5312 16.7218 11.4688 17.9218 10.1467 17.9218C8.82462 17.9218 7.76223 16.7218 7.76223 15.2608C7.76223 13.8261 8.80101 12.6522 10.0759 12.6V9.52175C7.26644 9.5739 5 12.1044 5 15.2608C5 18.4435 7.31366 21 10.1703 21C13.027 21 15.3406 18.4174 15.3406 15.2608V8.9739C16.3794 9.8087 17.6543 10.3043 19 10.3305V7.25217C16.9224 7.17391 15.2934 5.29565 15.2934 3Z" />
    </SvgIcon>
  );
});
